import { parse } from "papaparse";

/**
 * Retrieves and parses CSV data from a given URL.
 * 
 * @param {string} url - The URL of the CSV file.
 * @returns {Promise<Object[]>} - A promise that resolves to the parsed CSV data.
 */
export async function getCsvData(url) {
    try {
        const csvText = await fetchCsv(url);
        return new Promise((resolve, reject) => {
            parse(csvText, {
                header: true,
                complete: (results) => resolve(results.data),
                error: (error) => reject(error)
            });
        });
    } catch (error) {
        console.error('Error fetching or parsing CSV:', error);
        throw error;
    }
}

/**
 * Fetches CSV text from a given URL.
 * 
 * @param {string} url - The URL to fetch CSV from.
 * @returns {Promise<string>} - A promise that resolves to the CSV text.
 */
async function fetchCsv(url) {
    const response = await fetch(url);
    const reader = response.body.getReader();
    let csvText = '';
    const decoder = new TextDecoder('utf-8');

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        csvText += decoder.decode(value, { stream: true });
    }

    return csvText;
}